<span
    *ngIf="icon"
    class="grid h-10 w-10 place-items-center rounded-lg border border-slate-200 bg-slate-50 text-slate-700 transition group-hover:bg-slate-100"
    aria-hidden="true"
>
    <mat-icon> {{ icon }} </mat-icon>
</span>
